module.exports = __webpack_public_path__ + "static/images/components/UpgradeConfirmationView/images/bg.82bedeed.jpg";


//////////////////
// WEBPACK FOOTER
// ./components/UpgradeConfirmationView/images/bg.jpg
// module id = 2680
// module chunks = 11